// extracted by mini-css-extract-plugin
export var centerText = "_6m-8";
export var container = "_6m-0";
export var doughnutContainer = "_6m-7";
export var legend = "_6m-a";
export var legendItemColorDisplay = "_6m-b";
export var legendItemLabel = "_6m-d";
export var legendItemValue = "_6m-c";
export var lg = "_6m-5";
export var maxWidth = "_6m-9";
export var md = "_6m-4";
export var responsive = "_6m-6";
export var sm = "_6m-3";
export var xs = "_6m-2";
export var xxs = "_6m-1";